import axios from "axios";
import {useLoginStore} from "@/pinia";
import { dayjs } from "@/plugins/dayjs";

const API_URL = process.env.VUE_APP_API_URL;

console.log('Current Environment:', process.env.NODE_ENV);
console.log('Current API URL:', API_URL);

const instance = axios.create({
    baseURL: API_URL, // 기본 URL을 설정합니다.
    withCredentials: true, // CORS 요청 시 쿠키 전송 허용
    timeout: 10000, // 10초 타임아웃
});

// Request Interceptor
instance.interceptors.request.use(
    (config) => {
        const loginStore = useLoginStore();

        if (loginStore.jwtToken) {
            config.headers['Authorization'] = `Bearer ${loginStore.jwtToken}`;
        }

        if (loginStore.loginInfo && loginStore.loginInfo.userId) {
            config.headers['cms-user-id'] = loginStore.loginInfo.userId;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * 재귀적으로 객체 내 모든 날짜 문자열을 변환
 * UTC → 로컬 타임존 (선택사항)
 * 주의: 이 인터셉터는 선택사항입니다.
 * DateDisplay 컴포넌트를 사용하면 자동으로 변환되므로
 * 중복 변환을 방지하려면 이 함수를 비활성화하세요.
 */
function convertDatesToLocal(obj) {
    if (!obj || typeof obj !== 'object') return

    for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined) continue

        // ISO 8601 형식 감지: "2025-01-06T12:00:00Z"
        if (typeof obj[key] === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(obj[key])) {
            // 옵션 1: UTC 문자열 그대로 유지 (권장)
            // → DateDisplay 컴포넌트에서 변환
            // 아무것도 하지 않음

            // 옵션 2: 로컬 타임존으로 변환 (중복 변환 주의!)
            // obj[key] = dayjs.utc(obj[key]).local().format()
        } else if (typeof obj[key] === 'object') {
            convertDatesToLocal(obj[key]) // 재귀
        }
    }
}

// Response Interceptor (에러 처리 및 날짜 변환)
instance.interceptors.response.use(
    (response) => {
        // UTC → 로컬 변환 (선택사항)
        // 주의: DateDisplay 컴포넌트를 사용하면 중복 변환 발생
        // if (response.data) {
        //     convertDatesToLocal(response.data)
        // }

        return response;
    },
    (error) => {
        if (error.response) {
            const status = error.response.status;
            console.error('Response error:', status, error.response.data);

            // 401/403 에러 시 로그인 페이지로 리다이렉트
            if (status === 401 || status === 403) {
                const loginStore = useLoginStore();
                const requestUrl = error.config?.url || '';
                const isLoginPage = window.location.pathname === '/login';
                // 로그인 요청 자체이거나 이미 로그인 페이지면 리다이렉트하지 않음
                if (!requestUrl.includes('/api/login') && !isLoginPage) {
                    loginStore.jwtToken = null;
                    loginStore.loginInfo = null;
                    window.location.href = '/login';
                }
            }
        } else if (error.request) {
            // 요청은 보냈지만 응답이 없는 경우
            console.error('No response received:', error.request);
        } else {
            // 요청 설정 중 에러 발생
            console.error('Request setup error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default instance;
